export default "__VITE_ASSET__DxePKdk___"